// settings/autoBotsConfig.js
export const AUTO_BOTS = [
  {
    key: 'template_pipeline_no_answer_message_1',
    name: 'Недозвон — сообщение 1',
    trigger: 'При переводе сделки в "недозвон" (первое сообщение) ',
    defaultVariables: [],
  },
  {
    key: 'template_pipeline_no_answer_message_2',
    name: 'Недозвон — сообщение 2',
    trigger: 'При переводе сделки в "недозвон" (второе сообщение)',
    defaultVariables: [],
  },
  {
    key: 'template_pipeline_no_answer_message_3',
    name: 'Недозвон — сообщение 3',
    trigger: 'При переводе сделки в "недозвон" (третье сообщение)',
    defaultVariables: [],
  },
  {
    key: 'template_message_not_meeting',
    name: 'Неявка на встречу',
    trigger: 'При переводе сделки "Не пришел на встречу"',
    defaultVariables: [],
  },
  {
    key: 'template_message_meeting_held',
    name: 'Встреча проведена',
    trigger: 'При переводе сделки "Встреча проведена"',
    defaultVariables: [],
  },
  {
    key: 'template_pipeline_meeting_scheduled_message_1_online',
    name: 'Встреча назначена (онлайн) — сообщение 1',
    trigger:
      'При переводе сделки "Встреча назначена" (онлайн, первое сообщение)',
    defaultVariables: ['consultation_date', 'consultation_time'],
  },
  {
    key: 'template_pipeline_meeting_scheduled_message_1_offline',
    name: 'Встреча назначена (оффлайн) — сообщение 1',
    trigger:
      'При переводе сделки "Встреча назначена" (оффлайн, первое сообщение)',
    defaultVariables: ['consultation_date', 'address'],
  },
  {
    key: 'template_pipeline_meeting_scheduled_message_2',
    name: 'Встреча назначена — сообщение 2',
    trigger: 'При переводе сделки "Встреча назначена" (второе сообщение)',
    defaultVariables: [],
  },
  {
    key: 'template_pipeline_meeting_scheduled_message_3',
    name: 'Встреча назначена — сообщение 3',
    trigger: 'При переводе сделки "Встреча назначена" (третье сообщение)',
    defaultVariables: ['consultation_date'],
  },
]
